import React, { useState, useRef, useMemo } from "react";
import { CarouselProvider, Slide, Slider } from "pure-react-carousel";

import { BiVolumeMute, BiVolumeFull } from "react-icons/bi";
import { BsPlayFill, BsFillPauseFill } from "react-icons/bs";
import banner from "../../assets/banner/banner02.webp";

import "./banner.scss";

const Banner = ({ data }) => {
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isHidden, setIsHidden] = useState(false);
  const videoRef = useRef(null);

  function playTimeout() {
    if (isPlaying === true) {
      const timer = setTimeout(() => setIsHidden(true), 1500);
      return () => clearTimeout(timer);
    } else {
      setIsHidden(false);
    }
    return;
  }

  var hideMemo = useMemo(playTimeout, [isPlaying]);

  const togglePlay = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const toggleMute = () => {
    setIsMuted(!isMuted);
  };

  return (
    <CarouselProvider
      visibleSlides={1}
      totalSlides={data?.length}
      step={1}
      naturalSlideWidth={16}
      naturalSlideHeight={9}
      hasMasterSpinner={false}
      isPlaying={true}
      interval={5000}
      infinite={true}
      className="banner-carousel"
    >
      <Slider
        aria-label="Banner carousel"
      >
        {data.map((i, index) => (
          <Slide key={index} index={index}>
            {i.file_type === "video" ? (
              <div className="landingBannerVidContainer">
                <video
                  ref={videoRef}
                  autoPlay={true}
                  muted={isMuted}
                  loop={true}
                  playsinline
                  poster={banner}
                  aria-label={i.title || "Banner video"}
                >
                  <source src={i.file} type="video/webm"></source>
                </video>
                <button
                  type="button"
                  onClick={() => togglePlay()}
                  className="vid-overlay"
                  aria-label={isPlaying ? "Pause video" : "Play video"}
                  aria-pressed={isPlaying}
                  style={{ background: "transparent", border: "none", padding: 0, cursor: "pointer" }}
                >
                  {isPlaying ? (
                    <>
                      {!isHidden && (
                        <BsFillPauseFill
                          className="video-play-pause-btn"
                          color="#fff"
                          aria-hidden="true"
                          focusable="false"
                        />
                      )}
                    </>
                  ) : (
                    <BsPlayFill
                      className="video-play-pause-btn"
                      color="#fff"
                      aria-hidden="true"
                      focusable="false"
                    />
                  )}
                </button>

                <button
                  type="button"
                  onClick={() => toggleMute()}
                  className="vid-controls"
                  aria-label={isMuted ? "Unmute video" : "Mute video"}
                  aria-pressed={!isMuted}
                  style={{ background: "transparent", border: "none", padding: 0, cursor: "pointer" }}
                >
                  {!isMuted ? (
                    <BiVolumeFull
                      size="48px"
                      color="#fff"
                      aria-hidden="true"
                      focusable="false"
                    />
                  ) : (
                    <BiVolumeMute
                      size="48px"
                      color="#fff"
                      aria-hidden="true"
                      focusable="false"
                    />
                  )}
                </button>
              </div>
            ) : (
              <div className="landingBannerContainer" index={1}>
                <img
                  className="landingBanner"
                  src={i.file}
                  alt={i.title || `Banner image ${index + 1}`}
                />
              </div>
            )}
          </Slide>
        ))}
      </Slider>
    </CarouselProvider>
  );
};

export default Banner;
